export default function AppEntry() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="relative bg-gradient-to-br from-background-900 to-background-800 rounded-3xl overflow-hidden">
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20texture%20with%20soft%20golden%20light%20particles%20floating%20on%20dark%20background%2C%20elegant%20film%20projector%20light%20beam%20effect%2C%20warm%20amber%20and%20charcoal%20tones%2C%20subtle%20bokeh%20effect%2C%20no%20text%20no%20devices&width=1280&height=500&seq=app-bg-movie-03&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
          </div>

          <div className="relative flex flex-col md:flex-row items-center gap-8 md:gap-12 p-8 md:p-14">
            <div className="flex-shrink-0">
              <div className="w-36 h-36 md:w-44 md:h-44 rounded-3xl bg-background-950/80 border border-foreground-950/10 flex items-center justify-center">
                <i className="ri-smartphone-line text-5xl md:text-6xl text-primary-400"></i>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                移动观影
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-lg">
                无极电影网完美适配手机与平板，无需下载任何APP，打开浏览器即可畅享蓝光高清电影。躺在床上、通勤路上、午休间隙，随时随地想看就看。
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-4 mt-6">
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-950/40 border border-foreground-950/10">
                  <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">全平台适配</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-950/40 border border-foreground-950/10">
                  <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">无需下载</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-950/40 border border-foreground-950/10">
                  <i className="ri-checkbox-circle-fill text-primary-400 text-sm"></i>
                  <span className="text-xs md:text-sm text-foreground-700 whitespace-nowrap">流畅播放</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}